import { render, staticRenderFns } from "./CheckboxTemplate.vue?vue&type=template&id=29cc77bc"
import script from "./CheckboxTemplate.vue?vue&type=script&lang=js"
export * from "./CheckboxTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports